/**
 * Classe utilitaire pour la manipulation des composants Calendar
 */
export class CalendarUtils {

	/**
	 * Construit la plage des années selectionnables au format debut:fin compréhensible par le composant Calendar de PrimeNG
	 *  - début de plage : année de la date -10
	 *  - fin de plage : année de la date +5
	 *
	 * @param date la date à considérer
	 * @return la plage des années selectionnables
	 */
	static construirePlageAnnees(date: Date = new Date()): string {
		return `${date.getFullYear() - 10}:${date.getFullYear() + 5}`;
	}

	/**
	 * Construit la plage future des années selectionnables au format debut:fin compréhensible par le composant Calendar de PrimeNG
	 *  - début de plage : année de la date
	 *  - fin de plage : année de la date +5
	 *
	 * @param date la date à considérer
	 * @return la plage des années selectionnables
	 */
	static construirePlageAnneesFutur(date: Date = new Date()): string {
		return `${date.getFullYear()}:${date.getFullYear() + 5}`;
	}

	/**
	 * Renvoie la date d'hier
	 */
	static hier(): Date {
		const dateHier = new Date();
		dateHier.setDate(dateHier.getDate() - 1);
		return dateHier;
	}

}
